import type { FC } from 'react'
import { ChevronRight } from 'lucide-react'
import type { PortCall } from '../core/dashboard-types'
import CardInfoButton from './CardInfoButton'

const portCallsMeta = {
  description: 'Upcoming vessel port visits with ETA, purpose, and vessel details for the fleet.',
  endpoint: 'GET /operations/port-calls?status=SCHEDULED&sort=eta,asc&companyId={cgaId}',
  logic: 'Queries scheduled port calls sorted by upcoming ETA, limited to next arrivals. Each call shows vessel, port, ETA, and purpose.',
}

type Props = {
  portCalls: PortCall[]
  onViewAll?: () => void
  onPortCallClick?: (portCall: PortCall) => void
}

const PortCalls: FC<Props> = ({ portCalls, onViewAll, onPortCallClick }) => {
  return (
    <div className='card-hover bg-white rounded-2xl p-5 border border-slate-200 shadow-sm flex-1'>
      <div className='flex items-center justify-between mb-4'>
        <div className='flex items-center gap-2'>
          <h3 className='text-sm font-bold text-slate-900'>Upcoming Port Calls</h3>
          <CardInfoButton meta={portCallsMeta} />
        </div>
        <button className='text-[11px] text-blue-600 hover:underline flex items-center gap-0.5' onClick={onViewAll}>
          View all <ChevronRight className='w-3 h-3' />
        </button>
      </div>
      <div className='overflow-x-auto'>
        <table className='w-full text-left'>
          <thead>
            <tr className='text-[10px] text-slate-400 uppercase tracking-wider'>
              <th className='pb-2 font-medium'>Vessel</th>
              <th className='pb-2 font-medium'>Port</th>
              <th className='pb-2 font-medium'>ETA</th>
              <th className='pb-2 font-medium'>Purpose</th>
            </tr>
          </thead>
          <tbody className='text-[11px]'>
            {portCalls.length > 0 ? portCalls.map((pc) => (
              <tr
                key={pc.id}
                className='border-t border-slate-50 cursor-pointer hover:bg-slate-50 transition-colors'
                onClick={() => onPortCallClick?.(pc)}
              >
                <td className='py-2.5 font-medium text-slate-800'>{pc.vessel}</td>
                <td className='py-2.5 text-slate-600'>{pc.port}</td>
                <td className='py-2.5 text-slate-800 font-medium'>{pc.eta}</td>
                <td className='py-2.5 text-slate-500'>{pc.purpose}</td>
              </tr>
            )) : (
              <tr><td colSpan={4} className='py-10 text-center text-slate-400 text-xs'>No upcoming port calls</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default PortCalls
